import { ADD_TYPE_ID, REORDER_TYPE_IDS, REMOVE_TYPE_ID } from '../actions/typeId';
import { BUILDER_TYPES } from '../../config/constants';
import { store } from '../store';
import { addInputWithProps, removeInputWithProps } from '../actions/inputWithProps';

const DEFAULT_STATE = {
    [BUILDER_TYPES.FORM]: [],
    [BUILDER_TYPES.SUCCESS_PAGE]: []
};

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case ADD_TYPE_ID: {
            setTimeout(_ => store.dispatch(addInputWithProps(action.payload)));

            const { typeId, activeBuilderType } = action.payload;
            const curVal = [...state[activeBuilderType]];
            return {
                ...state,
                [activeBuilderType]: [...curVal, typeId]
            };
        }

        case REMOVE_TYPE_ID: {
            setTimeout(_ => store.dispatch(removeInputWithProps(action.payload.itemId)));

            const { itemId, activeBuilderType } = action.payload;
            const curVal = [...state[activeBuilderType]];
            return {
                ...state,
                [activeBuilderType]: curVal.filter(el => el.id !== itemId)
            };
        }

        case REORDER_TYPE_IDS: {
            const { typeIds, activeBuilderType } = action.payload;
            return {
                ...state,
                [activeBuilderType]: typeIds
            };
        }

        default: return state;
    }
}
